import React, { useState } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import {
    Dialog,
    DialogPanel,
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    Popover,
    PopoverButton,
    PopoverGroup,
    PopoverPanel,
} from '@headlessui/react'
import {
    Bars3Icon,
    FingerPrintIcon,
    XMarkIcon,
    GlobeAltIcon,
    BuildingLibraryIcon,
    ChatBubbleBottomCenterTextIcon
} from '@heroicons/react/24/outline'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import logo from "../../../public/images/logo.png";
import ModalContact from './ModalContact'


export default function Header() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
    const [open, setOpen] = useState(false)
    const navigate = useNavigate();

    const location = useLocation();
    const isActive = (path) => location.pathname.startsWith(path);
    const products = [
        { name: 'Main Web', description: 'SMA Negeri 2 Amlapura Main Web', to: 'https://sman2amlapura.sch.id', icon: GlobeAltIcon },
        { name: 'Dashboard Admin', description: 'Login to customize this pages', to: 'https://admin.sman2amlapura.sch.id', icon: BuildingLibraryIcon },
        { name: 'SIM Smandapura', description: 'List More Application in SMA Negeri 2 Amlapura', to: 'https://sim.sman2amlapura.sch.id', icon: FingerPrintIcon },
    ]
    const callsToAction = [
        { name: 'Leave Message', to: '#', icon: ChatBubbleBottomCenterTextIcon, click: () => { setOpen(true); setMobileMenuOpen(false); } },
    ]

    const handleHeaderClick = (to) => {
        navigate(`${to}`);
    };

    return (
        <>
            <header className="sticky top-0 z-30 bg-smanda">
                <nav aria-label="Global" className="flex justify-between items-center p-6 mx-auto max-w-7xl lg:px-8">
                    <div className="flex lg:flex-1">
                        <Link to="/" className="-m-1.5 p-1.5 flex items-center">
                            <span className="sr-only">Smandapura</span>
                            <img
                                alt=""
                                src={logo}
                                className="mr-3 w-auto h-8"
                            />
                            <span className="text-2xl font-semibold text-white font-kaushan">
                                Smandapura
                            </span>

                        </Link>
                    </div>
                    <div className="flex lg:hidden">
                        <button
                            type="button"
                            onClick={() => setMobileMenuOpen(true)}
                            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-white"
                        >
                            <span className="sr-only">Open main menu</span>
                            <Bars3Icon aria-hidden="true" className="size-6" />
                        </button>
                    </div>
                    <PopoverGroup className="hidden lg:flex lg:gap-x-12">
                        <Link
                            to="/article"
                            className={`relative p-2 text-sm font-semibold text-white rounded-md group`}
                        >
                            Artikel
                            <span
                                className={`absolute bottom-0 left-0 w-full bg-white transition-all duration-300 h-[2px] ${isActive("/article")
                                    ? "opacity-100 scale-x-100"
                                    : "opacity-0 scale-x-0 group-hover:scale-x-100 group-hover:opacity-100"
                                    }`}
                            />
                        </Link>
                        <Link
                            to="/team"
                            className={`relative p-2 text-sm font-semibold text-white rounded-md group`}
                        >
                            Proker
                            <span
                                className={`absolute bottom-0 left-0 w-full bg-white transition-all duration-300 h-[2px] ${isActive("/team")
                                    ? "opacity-100 scale-x-100"
                                    : "opacity-0 scale-x-0 group-hover:scale-x-100 group-hover:opacity-100"
                                    }`}
                            />
                        </Link>
                        <Link
                            to="/extra"
                            className={`relative p-2 text-sm font-semibold text-white rounded-md group`}
                        >
                            Extra
                            <span
                                className={`absolute bottom-0 left-0 w-full bg-white transition-all duration-300 h-[2px] ${isActive("/extra")
                                    ? "opacity-100 scale-x-100"
                                    : "opacity-0 scale-x-0 group-hover:scale-x-100 group-hover:opacity-100"
                                    }`}
                            />
                        </Link>
                        <Link
                            to="/gallery"
                            className={`relative p-2 text-sm font-semibold text-white rounded-md group`}
                        >
                            Galeri
                            <span
                                className={`absolute bottom-0 left-0 w-full bg-white transition-all duration-300 h-[2px] ${isActive("/gallery")
                                    ? "opacity-100 scale-x-100"
                                    : "opacity-0 scale-x-0 group-hover:scale-x-100 group-hover:opacity-100"
                                    }`}
                            />
                        </Link>
                        <Link to="/#about-us" onClick={(e) => {
                            if (window.location.pathname === "/") {
                                e.preventDefault();
                                document.getElementById("about-us")?.scrollIntoView({ behavior: "smooth" });
                            }
                        }
                        } className="relative p-2 font-semibold text-white rounded-md text-sm/6 group">
                            About Us
                            <span
                                className="absolute left-0 bottom-0 w-full h-[2px] bg-white opacity-0 scale-x-0 transition-all duration-300 group-hover:scale-x-100 group-hover:opacity-100"
                            />

                        </Link>
                        <Popover className="relative">
                            <PopoverButton className="flex gap-x-1 items-center p-2 font-semibold text-white text-sm/6">
                                Software
                                <ChevronDownIcon aria-hidden="true" className="flex-none text-white size-5" />
                            </PopoverButton>

                            <PopoverPanel
                                transition
                                className="absolute -left-8 top-full z-10 mt-3 w-screen max-w-md overflow-hidden rounded-3xl bg-white shadow-lg ring-1 ring-gray-900/5 transition data-[closed]:translate-y-1 data-[closed]:opacity-0 data-[enter]:duration-200 data-[leave]:duration-150 data-[enter]:ease-out data-[leave]:ease-in"
                            >
                                <div className="p-4">
                                    {products.map((item) => (
                                        <div
                                            key={item.name}
                                            className="flex relative gap-x-6 items-center p-4 rounded-lg group text-sm/6 hover:bg-gray-50"
                                        >
                                            <div className="flex flex-none justify-center items-center bg-gray-50 rounded-lg size-11 group-hover:bg-white">
                                                <item.icon aria-hidden="true" className="text-slate-600 size-6 group-hover:text-indigo-600" />
                                            </div>
                                            <div className="flex-auto">
                                                <Link to={item.to} className="block font-semibold text-slate-900">
                                                    {item.name}
                                                    <span className="absolute inset-0" />
                                                </Link>
                                                <span className="mt-1 text-slate-600">{item.description}</span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className="grid grid-cols-1 bg-gray-50 divide-x divide-gray-900/5">
                                    {callsToAction.map((item) => (
                                        <Link
                                            key={item.name}
                                            onClick={item.click}
                                            className="cursor-pointer flex items-center justify-center gap-x-2.5 p-3 text-sm/6 font-semibold text-slate-900 hover:bg-gray-100"
                                        >
                                            <item.icon aria-hidden="true" className="flex-none text-slate-400 size-5" />
                                            {item.name}
                                        </Link>
                                    ))}
                                </div>
                            </PopoverPanel>
                        </Popover>
                    </PopoverGroup>
                    <div className="hidden lg:flex lg:flex-1 lg:justify-end">
                        <Link to="https://admin.sman2amlapura.sch.id/login" className="font-semibold text-white text-sm/6">
                            Log in <span aria-hidden="true">&rarr;</span>
                        </Link>
                    </div>
                </nav>
                <Dialog open={mobileMenuOpen} onClose={setMobileMenuOpen} className="lg:hidden">
                    <div className="fixed inset-0 z-10" />
                    <DialogPanel className="overflow-y-auto fixed inset-y-0 right-0 z-40 px-6 py-6 w-full bg-smanda sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
                        <div className="flex justify-between items-center">
                            <Link to="/" className="-m-1.5 p-1.5">
                                <span className="sr-only">Smandapura</span>
                                <img
                                    alt=""
                                    src={logo}
                                    className="w-auto h-8"
                                />
                            </Link>
                            <button
                                type="button"
                                onClick={() => setMobileMenuOpen(false)}
                                className="-m-2.5 rounded-md p-2.5 text-white"
                            >
                                <span className="sr-only">Close menu</span>
                                <XMarkIcon aria-hidden="true" className="size-6" />
                            </button>
                        </div>
                        <div className="flow-root mt-6">
                            <div className="-my-6 divide-y divide-gray-500/10">
                                <div className="py-6 space-y-2">
                                    <Link
                                        to="/article"
                                        onClick={() => setMobileMenuOpen(false)}
                                        className={`block px-3 py-2 -mx-3 font-semibold text-white rounded-lg text-base/7 hover:bg-smanda-active ${isActive("/article") ? "pointer-events-none bg-smanda-active" : ""}`}
                                    >
                                        Artikel
                                    </Link>
                                    <Link
                                        to="/team"
                                        onClick={() => setMobileMenuOpen(false)}
                                        className={`block px-3 py-2 -mx-3 font-semibold text-white rounded-lg text-base/7 hover:bg-smanda-active ${isActive("/team") ? "pointer-events-none bg-smanda-active" : ""}`}
                                    >
                                        Proker
                                    </Link>
                                    <Link
                                        to="/extra"
                                        onClick={() => setMobileMenuOpen(false)}
                                        className={`block px-3 py-2 -mx-3 font-semibold text-white rounded-lg text-base/7 hover:bg-smanda-active ${isActive("/extra") ? "pointer-events-none bg-smanda-active" : ""}`}
                                    >
                                        Extra
                                    </Link>
                                    <Link
                                        to="/gallery"
                                        onClick={() => setMobileMenuOpen(false)}
                                        className={`block px-3 py-2 -mx-3 font-semibold text-white rounded-lg text-base/7 hover:bg-smanda-active ${isActive("/gallery") ? "pointer-events-none bg-smanda-active" : ""}`}
                                    >
                                        Galeri
                                    </Link>
                                    <Link
                                        to="/#about-us"
                                        onClick={(e) => {
                                            setMobileMenuOpen(false)
                                            if (window.location.pathname === "/") {
                                                e.preventDefault();
                                                document.getElementById("about-us")?.scrollIntoView({ behavior: "smooth" });
                                            }
                                        }}
                                        className="block px-3 py-2 -mx-3 font-semibold text-white rounded-lg text-base/7 hover:bg-smanda-active"
                                    >
                                        About Us
                                    </Link>
                                    <Disclosure as="div" className="-mx-3">
                                        <DisclosureButton className="group flex w-full items-center justify-between rounded-lg py-2 pl-3 pr-3.5 text-base/7 font-semibold text-white hover:bg-smanda-active">
                                            Software
                                            <ChevronDownIcon aria-hidden="true" className="size-5 flex-none group-data-[open]:rotate-180" />
                                        </DisclosureButton>
                                        <DisclosurePanel className="mt-2 space-y-2">
                                            {[...products, ...callsToAction].map((item) => (
                                                <DisclosureButton
                                                    as="a"
                                                    key={item.name}
                                                    href={item.to ?? '#'}
                                                    onClick={item.click ?? (() => { setMobileMenuOpen(false); })}
                                                    className="block py-2 pr-3 pl-6 font-semibold text-white rounded-lg text-sm/7 hover:bg-smanda-active"
                                                >
                                                    {item.name}
                                                </DisclosureButton>
                                            ))}
                                        </DisclosurePanel>
                                    </Disclosure>
                                </div>
                                <div className="py-6">
                                    <Link
                                        to="https://admin.sman2amlapura.sch.id/login"
                                        className="-mx-3 block rounded-lg px-3 py-2.5 text-base/7 font-semibold text-white hover:bg-smanda-active"
                                    >
                                        Log in
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </DialogPanel>
                </Dialog>
            </header>
            <ModalContact open={open} setOpen={setOpen} />
        </>
    )
}
